import Vector2 from './Vector2';
import { valueInRange as checkValueInRange } from './Util';

export default class Rect {
    private _position: Vector2; 
    private _size: Vector2;

    public static fromExtents(startPoint: Vector2, endPoint: Vector2): Rect {
        var minX = Math.min(startPoint.x, endPoint.x);
        var minY = Math.min(startPoint.y, endPoint.y);

        var maxX = Math.max(startPoint.x, endPoint.x);
        var maxY = Math.max(startPoint.y, endPoint.y);

        return new Rect(new Vector2(minX, minY), new Vector2(maxX - minX, maxY - minY));
    }
    
    public static fromVectors(vecs: Array<Vector2>): Rect {
        if(vecs.length == 0) {
            return new Rect();
        }

        var xValues = new Array<number>(vecs.length);
        var yValues = new Array<number>(vecs.length);

        for(var i = 0; i < vecs.length; i++) {
            var vec = vecs[i];
          
            xValues[i] = vec.x;
            yValues[i] = vec.y;

        }

        var minX = Math.min(...xValues);
        var minY = Math.min(...yValues);

        var maxX = Math.max(...xValues);
        var maxY = Math.max(...yValues);

        return Rect.fromExtents(new Vector2(minX, minY), new Vector2(maxX, maxY));
    }

    public static combineRects(rects: Array<Rect>): Rect {
        if(rects.length == 0) {
            return new Rect();
        }

        var xValues = new Array<number>(rects.length * 2);
        var yValues = new Array<number>(rects.length * 2);

        for(var i = 0; i < rects.length; i++) {
            var rect = rects[i];
            var endPoint = rect.getEndPoint();
            xValues[i * 2] = rect.position.x;
            xValues[i * 2 + 1] = endPoint.x;

            yValues[i * 2] = rect.position.y;
            yValues[i * 2 + 1] = endPoint.y;
        }

        var minX = Math.min(...xValues);
        var minY = Math.min(...yValues);

        var maxX = Math.max(...xValues);
        var maxY = Math.max(...yValues);

        return Rect.fromExtents(new Vector2(minX, minY), new Vector2(maxX, maxY));
    }

    public constructor(position = new Vector2(), size = new Vector2()) {
        this._position = position;
        this._size =  size;
    }

    public checkPointIntersection(point: Vector2): boolean {
        var minX = Math.min(this._position.x, this._position.x + this._size.x);
        var minY = Math.min(this._position.y, this._position.y + this._size.y);

        var maxX = Math.max(this._position.x, this._position.x + this._size.x);
        var maxY = Math.max(this._position.y, this._position.y + this._size.y);


        return point.x > minX && point.y > minY && point.x < maxX && point.y < maxY;
    }



    public get position(): Vector2 {
        return this._position;
    }

    public get size(): Vector2 {
        return this._size;
    }

    public getEndPoint(): Vector2 {
        return this._position.add(this._size);
    }

    public getCenterPoint(): Vector2 {
        return this._position.add(this._size.mulScalar(0.5));
    }

    public add(offset: Vector2): Rect {
        return new Rect(this.position.add(offset), this.size);
    }
}